import React from "react";
import { motion } from "framer-motion";
import AnimatedHeading from "./AnimatedHeading";
import useMotionGuard from "../hooks/useMotionGuard";

const TAGS = ["ARERA", "SII", "Accise", "Fatturazione", "Modulistica", "Recupero crediti"];

/**
 * Marquee ticker orizzontale continuo per i tag.
 * - Su reduced-motion: fallback a lista wrap statica (nessuno scroll infinito).
 * - Duplichiamo la lista e traslamo di -50% in loop lineare → seamless.
 */
export default function SectionIntro() {
    const { reduced } = useMotionGuard();
    const doubled = [...TAGS, ...TAGS];

    return (
        <section className="lp-section" aria-labelledby="s-intro" id="metodo">
            <div className="lp-container">
                <div className="lp-section-head">
                    <motion.div
                        className="lp-eyebrow lp-section-eyebrow"
                        initial={{ opacity: 0, y: 12 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <span className="lp-eyebrow-accent">01</span> &nbsp;/&nbsp; Il problema
                    </motion.div>
                    <AnimatedHeading
                        as="h2"
                        id="s-intro"
                        className="lp-h2"
                        text="Partire da zero sembra impossibile."
                    />
                    <motion.p
                        className="lp-body-lg lp-section-sub"
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.25 }}
                    >
                        ARERA, SII, accise, fatturazione elettronica, modulistica, unbundling, recupero crediti. Ogni pezzo è un mondo. E ti serve tutto, dal giorno uno.
                    </motion.p>
                </div>

                {reduced ? (
                    <div className="lp-tags" role="list">
                        {TAGS.map((t) => (
                            <span key={t} className="lp-tag" role="listitem">{t}</span>
                        ))}
                    </div>
                ) : (
                    <motion.div
                        className="lp-marquee-wrap"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                        data-testid="intro-marquee"
                    >
                        <motion.div
                            className="lp-marquee-track"
                            animate={{ x: ["0%", "-50%"] }}
                            transition={{ ease: "linear", duration: 28, repeat: Infinity }}
                        >
                            {doubled.map((t, i) => (
                                <span key={`${t}-${i}`} className="lp-tag" aria-hidden={i >= TAGS.length}>
                                    {t}
                                </span>
                            ))}
                        </motion.div>
                    </motion.div>
                )}
            </div>
        </section>
    );
}
